/**
 * @file utils.js
 * @description Global utility functions for the OS.
 * @version 2.0.0 (Refactored)
 */

export const Utils = {
    sleep: (ms) => new Promise(resolve => setTimeout(resolve, ms)),
    
    randomInt: (min, max) => Math.floor(Math.random() * (max - min + 1)) + min,
    
    playBeep: () => {
        try {
            const audioContext = new (window.AudioContext || window.webkitAudioContext)();
            const oscillator = audioContext.createOscillator();
            const gainNode = audioContext.createGain();
            oscillator.type = 'sine';
            oscillator.frequency.setValueAtTime(880, audioContext.currentTime);
            gainNode.gain.setValueAtTime(0.1, audioContext.currentTime);
            oscillator.connect(gainNode);
            gainNode.connect(audioContext.destination);
            oscillator.start();
            oscillator.stop(audioContext.currentTime + 0.05);
        } catch (e) {
            console.warn('WebAudio API not supported, skipping boot beep.', e);
        }
    }
};